const parseAffiliateLinks = (affiliateLinks) => {
  if (Array.isArray(affiliateLinks)) {
    return affiliateLinks;
  }

  if (typeof affiliateLinks === 'string') {
    const trimmedAffiliateLinks = affiliateLinks.trim();

    if (!trimmedAffiliateLinks) {
      return [];
    }

    try {
      const parsedAffiliateLinks = JSON.parse(trimmedAffiliateLinks);
      return Array.isArray(parsedAffiliateLinks) ? parsedAffiliateLinks : [];
    } catch (error) {
      return [];
    }
  }

  return [];
};

const toAffiliateLinkDraft = (affiliateLink = {}) => ({
  label: String(
    affiliateLink?.label ??
    affiliateLink?.text ??
    affiliateLink?.word ??
    affiliateLink?.name ??
    ''
  ),
  url: String(
    affiliateLink?.url ??
    affiliateLink?.href ??
    affiliateLink?.link ??
    ''
  )
});

const sanitizeAffiliateLink = (affiliateLink = {}) => ({
  label: toAffiliateLinkDraft(affiliateLink).label.trim(),
  url: toAffiliateLinkDraft(affiliateLink).url.trim()
});

const isValidAffiliateUrl = (url) => {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
  } catch (error) {
    return false;
  }
};

export const createEmptyAffiliateLink = () => ({
  label: '',
  url: ''
});

export const normalizeAffiliateLinksForEditor = (affiliateLinks) =>
  parseAffiliateLinks(affiliateLinks)
    .map(toAffiliateLinkDraft);

export const normalizeAffiliateLinks = (affiliateLinks) =>
  normalizeAffiliateLinksForEditor(affiliateLinks)
    .filter((affiliateLink) => affiliateLink.label && affiliateLink.url);

export const validateAffiliateLinks = (affiliateLinks, itemLabel = 'Affiliate link') => {
  const links = normalizeAffiliateLinksForEditor(affiliateLinks);

  for (let index = 0; index < links.length; index += 1) {
    const affiliateLink = sanitizeAffiliateLink(links[index]);

    if (!affiliateLink.label && !affiliateLink.url) {
      continue;
    }

    if (!affiliateLink.label || !affiliateLink.url) {
      return `${itemLabel} ${index + 1} must include both link text and URL.`;
    }

    if (!isValidAffiliateUrl(affiliateLink.url)) {
      return `${itemLabel} ${index + 1} must use a valid http:// or https:// URL.`;
    }
  }

  return '';
};
